/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Portal_Invite_Email_Not_SentInputs */

const cs_client_portal_invite_email_not_sent = /** @type {(inputs: Client_Portal_Invite_Email_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail s pozvánkou se neodeslal. Zkopírujte odkaz a pošlete ho sami.`)
};

const en_client_portal_invite_email_not_sent = /** @type {(inputs: Client_Portal_Invite_Email_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite email was not sent. Copy the link and send it yourself.`)
};

/**
* | output |
* | --- |
* | "Invite email was not sent. Copy the link and send it yourself." |
*
* @param {Client_Portal_Invite_Email_Not_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_portal_invite_email_not_sent = /** @type {((inputs?: Client_Portal_Invite_Email_Not_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Portal_Invite_Email_Not_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_portal_invite_email_not_sent(inputs)
	return cs_client_portal_invite_email_not_sent(inputs)
});